module.exports = __webpack_public_path__ + "media/country_flags/mm-23f41e24.png";